import { render } from "./FilePreviewCheck.vue?vue&type=template&id=5f121960"
import script from "./FilePreviewCheck.vue?vue&type=script&lang=js"
export * from "./FilePreviewCheck.vue?vue&type=script&lang=js"

import "./FilePreviewCheck.vue?vue&type=style&index=0&id=5f121960&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__